import React from 'react';
import { Typography } from '@/UI/Components/Typography/Typography';
import DownloadAppButton from '@/UI/Components/DownloadAppButton/DownloadAppButton';
import { CheckCircle, FileText } from 'react-feather';

const LegalPerson: React.FC = () => {
	return (
		<div className="bg-gradient-to-br from-[#4660ff] via-[#5a75ff] to-[#6e8aff] min-h-screen flex items-center justify-center p-4">
			<div className="w-full max-w-lg">
				<div className="bg-white rounded-2xl shadow-2xl overflow-hidden transform transition-all duration-300 hover:shadow-3xl">
					<div className="bg-gradient-to-r from-[#4660ff] to-[#5a75ff] p-6 md:p-8">
						<div className="flex flex-col items-center gap-4">
							<div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-lg transform transition-transform duration-300 hover:scale-105">
								<img src="/black-logo.png" alt="Fincluyente" className="w-16 h-16 object-contain" />
							</div>
						</div>
					</div>

					<div className="p-6 md:p-8 space-y-6">
						<div className="flex items-start gap-3 bg-green-50 rounded-xl p-4 border border-green-100">
							<CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
							<Typography size={16} weight="semibold" color="black">
								Tu información fue registrada correctamente, siguientes pasos:
							</Typography>
						</div>

						<div className="space-y-4">
							<div className="flex items-start gap-4 group">
								<div className="flex-shrink-0 w-10 h-10 bg-[#4660ff] rounded-full flex items-center justify-center text-white font-bold shadow-md group-hover:scale-110 transition-transform duration-200">
									<span>1</span>
								</div>
								<div className="flex-1 pt-2">
									<Typography size={16} weight="semibold" color="black">
										Tu solicitud será revisada por nuestro equipo.
									</Typography>
								</div>
							</div>

							<div className="flex items-start gap-4 group">
								<div className="flex-shrink-0 w-10 h-10 bg-[#4660ff] rounded-full flex items-center justify-center text-white font-bold shadow-md group-hover:scale-110 transition-transform duration-200">
									<span>2</span>
								</div>
								<div className="flex-1 pt-2">
									<Typography size={16} weight="semibold" color="black">
										Nos pondremos en contacto ustedes para continuar con el proceso.
									</Typography>
								</div>
							</div>
						</div>

						<div className="pt-4 border-t border-gray-200">
							<div className="flex flex-col items-center gap-4">
								<div className="flex flex-col items-center gap-2 text-gray-600">
									<FileText className="w-5 h-5" />
									<Typography size={15} color="subtitle">
										Finclu Empresas
									</Typography>
								</div>
								<div className="pt-2">
									<DownloadAppButton buttonColor="#4660ff" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default LegalPerson;
